// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_111","colBig":"styles_colBig__2X8vg","colSmall":"styles_colSmall__TGtrX","shopifyNameWrapper":"styles_shopifyNameWrapper__wSuHm"};